module.exports = __webpack_public_path__ + "static/media/edit_icon.7f184c20.svg";